<script setup>
import {useModalsStore} from '@/stores/modals'

// Pinia Stores
const modalsStore = useModalsStore()

// --- Methods ---

const openThemesEditorAddModal = () => {
    modalsStore.show({
        componentName: 'ThemesEditorAddModal',
        obj: {
            id: 0,
        }
    })
}
</script>

<template>
    <button class="dropdown-item d-flex align-items-center" type="button" @click="openThemesEditorAddModal">
        <i class="me-2 bi-plus-lg"/>
        New
    </button>
</template>